/**
 *  ToggleButton script file
**/

export default {
  name: 'ToggleButton',
  mixins: [],
  components: {},
  props: {
    buttons: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'text',
      required: false,
      validator (value) {
        const options = [
          'text',
          'icon',
          'icon-text',
          'text-icon'
        ]
        return options.indexOf(value) !== -1
      }
    },
    size: {
      type: String,
      default: 'default',
      required: false,
      validator (value) {
        const options = [
          'small',
          'default',
          'large'
        ]
        return options.indexOf(value) !== -1
      }
    }
  },
  data () {
    return {
      activeButton: undefined
    }
  },
  created () {
    this.activeButton = this.buttons.find(button => button.active).id
  },
  computed: {
  },
  methods: {
    selectButton (selected) {
      this.activeButton = selected.id
      this.$emit('select', selected)
    }
  }
}
